<template>
  <router-view/>
</template>

<script>
import { kickAgent } from '@/utils/agentSession'

export default {
  name: 'App',
  mounted () {
    window.addEventListener('agent-session-kicked', this.onAgentKicked)
  },
  beforeUnmount () {
    window.removeEventListener('agent-session-kicked', this.onAgentKicked)
  },
  methods: {
    onAgentKicked () {
      if (this.$route.name === 'agent-kicked') return
      kickAgent(this.$router)
    }
  }
}
</script>

<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

:root {
  --sidebar-width: 280px;
}

.main-content {
  margin-left: var(--sidebar-width) !important;
  transition: margin-left 0.3s ease;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0 !important;
  }
}
</style>
